import type { TratamentoAdvogado } from '@/api/secretario';
import { Button } from '@/components/ui/button';

/** Dr. ou Dra.: o palpite pelo prenome vem marcado; um clique troca. */
export function EscolhaDeTratamento({
  valor,
  onEscolher,
}: {
  valor: string;
  onEscolher: (t: TratamentoAdvogado) => void;
}) {
  return (
    <div className="flex gap-2">
      {(['DR', 'DRA'] as const).map((opcao) => (
        <Button
          key={opcao}
          type="button"
          size="sm"
          className="min-h-11 min-w-16 sm:min-h-9"
          variant={valor === opcao ? 'default' : 'outline'}
          onClick={() => onEscolher(opcao)}
        >
          {opcao === 'DR' ? 'Dr.' : 'Dra.'}
        </Button>
      ))}
    </div>
  );
}
